import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const surveyFormLocaleModule: LocaleModule = {
  name: "surveyForm",
  messages: { en: en, it: it },
};
